type SearchInputProps = {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
};

export const SearchInput = ({
  value,
  onChange,
  placeholder = "検索...",
}: SearchInputProps) => {
  return (
    <div className="relative w-full">
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full h-[30px] rounded-md text-sm py-1.5 pl-9 pr-3 border-border-color !border-[1px] !border-solid outline-none box-border font-sans bg-bg-white text-black appearance-none"
      />
      <span className="material-symbols-outlined absolute left-2.5 top-1/2 transform -translate-y-1/2 text-xl text-text-secondary">
        search
      </span>
    </div>
  );
};
